<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="出库单号" label-width="90px">
        <el-input v-model="queryParam.exportNo" clearable></el-input>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>出库单列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
            <el-button type="primary" @click="showPrint()">
              打印签收单
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="orders" @selection-change="handleSelectionChange" border>
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="createDate" label="时间"></el-table-column>
      <el-table-column prop="exportNo" label="出库单号"></el-table-column>
      <el-table-column prop="factoryCompanyName" label="门店名称"></el-table-column>
      <el-table-column label="油量">
        <template #default="scope">
          {{scope.row.oilNum + '桶'}}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template #default="scope">
          {{scope.row.status === 0 ? '待发货' : scope.row.factoryRecStatus === 0 ? '待收货' : '已收货'}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showDetail(scope.row)">详情</el-link>
          <el-dropdown>
            <span class="cursor_pointer color_normal">
              操作<el-icon><arrow-down/></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="showPrint(scope.row)">打印签收单</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.factoryRecStatus === 1" @click="showFeedbackPic(scope.row)">查看回执单</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.status === 0" @click="showDetail(scope.row, true)">发货</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.status === 1 && scope.row.factoryRecStatus === 0" @click="showConfirm(scope.row)">确认收货</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.factoryRecStatus === 1" @click="showConfirm(scope.row)">上传回执单</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog :title="!send ? '详情' : '发货'" v-model="detailVisible" custom-class="dialog_width_large" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-table :data="order.details" border>
      <el-table-column type="index" label="序号"></el-table-column>
      <!--
      <el-table-column label="图片">
        <template #default="scope">
          <img :src="$utils.imageSrc(scope.row.pic)"/>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column label="类型">
        <template #default="scope">
          {{scope.row.type === 0 ? '油品' : '物料'}}
        </template>
      </el-table-column>
      <el-table-column label="数量">
        <template #default="scope">
          {{scope.row.quantity + scope.row.unit}}
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" v-if="send" @click="confirmSend" style="margin-top: 12px;">确认发货</el-button>
  </el-dialog>

  <el-dialog :title="isConfirm ? '确认收货' : '修改回执单'" v-model="confirmVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="sendForm">
      <el-form-item label="回执单" label-width="88px">
        <el-upload class="image_uploader" :action="apiBase + 'api/v1/common/upload/image/factory_feedback'" :show-file-list="false"
                   :on-success="handleSuccess" :before-upload="beforeUpload">
          <img v-if="order.factoryFeedbackPic" :src="$utils.imageSrc(order.factoryFeedbackPic)"/>
          <el-icon v-else class="uploader_icon"><plus /></el-icon>
        </el-upload>
      </el-form-item>
      <el-button type="primary" @click="confirmIn">{{isConfirm ? '确认收货' : '确定'}}</el-button>
    </el-form>
  </el-dialog>

  <el-dialog title="签收单" v-model="printVisible" custom-class="dialog_width_large" :close-on-click-modal="false" :close-on-press-escape="false">
    <div id="print" style="font-size: 14px;font-weight: normal;">
      <div style="text-align: center;font-size: 22px;font-weight: bold;">签收单</div>
      <div style="width: 100%;display: flex;line-height: 32px;">
        <div style="flex: 1.3;text-align: left;">门店名称：{{order.factoryCompanyName}}</div>
        <div style="flex: 1;text-align: left;">签收人：<span style="display: inline-block;width: 130px;height: 18px;vertical-align: middle;border-bottom: 1px solid #8B8C8D;"></span></div>
        <div style="flex: 1;text-align: right;">时间：<span style="display: inline-block;width: 130px;height: 18px;vertical-align: middle;border-bottom: 1px solid #8B8C8D;"></span></div>
      </div>
      <table style="border-collapse: collapse;border-spacing: 0;width: 100%;line-height: 36px;text-align: center;">
        <thead>
        <tr>
          <th style="border: 1px solid #EBEEF5;">序号</th>
          <th style="border: 1px solid #EBEEF5;">名称</th>
          <th style="border: 1px solid #EBEEF5;">类型</th>
          <th style="border: 1px solid #EBEEF5;">数量</th>
          <th style="border: 1px solid #EBEEF5;">单号</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in order.details" :key="index">
          <td style="border: 1px solid #EBEEF5;">{{index + 1}}</td>
          <td style="border: 1px solid #EBEEF5;">{{item.name}}</td>
          <td style="border: 1px solid #EBEEF5;">{{item.type === 0 ? '油品' : '物料'}}</td>
          <td style="border: 1px solid #EBEEF5;">{{item.quantity + item.unit}}</td>
          <td style="border: 1px solid #EBEEF5;">{{item.exportNo}}</td>
        </tr>
        </tbody>
      </table>
      <div style="width: 100%;display: flex;line-height: 32px;">
        <div style="flex: 1.3;text-align: left;">服务商名称：{{order.agentCompanyName}}</div>
        <div style="flex: 1;text-align: right;">时间：{{order.createDate}}</div>
      </div>
    </div>
    <el-button type="primary" v-print="'#print'" @click="print" style="margin-top: 12px;">打印</el-button>
  </el-dialog>

  <el-image-viewer v-if="showViewer" @close="closeViewer" :url-list="viewerUrls" />
</template>

<script>
export default {
  name: "出库单",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      apiBase: process.env.VUE_APP_API_BASE,
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      orders: [],
      order: {},
      detailVisible: false,
      send: false,
      confirmVisible: false,
      isConfirm: true,
      checkedOrders: [],
      printVisible: false,
      showViewer: false,
      viewerUrls: []
    }
  },
  methods: {
    beforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLes5M = file.size / 1024 / 1024 < 5
      if (!isImg) {
        this.$message.error('图片只能是 JPG 格式!')
      }
      if (!isLes5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isImg && isLes5M
    },
    handleSelectionChange(val) {
      this.checkedOrders = val
    },
    handleSuccess(res, file) {
      this.order.factoryFeedbackPic = res.data
    },
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.store.agentOutList(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        let orders = response.data.data
        orders.forEach(item => item.oilNum = item.agentExportGoodsItemVOS.filter(subItem => subItem.type === 0).reduce((total, subItem) => total + subItem.quantity, 0))
        this.orders = orders
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    showDetail(order, send) {
      this.detailVisible = true
      this.send = send
      this.order = {
        sn: order.sn,
        details: order.agentExportGoodsItemVOS
      }
    },
    confirmSend() {
      this.$apis.store.agentSend(this.order.sn).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '发货成功',
            type: 'success'
          })
          this.detailVisible = false
          this.list()
        }
      })
    },
    showConfirm(order) {
      this.confirmVisible = true
      this.isConfirm = order.factoryRecStatus !== 1
      this.order = {
        sn: order.sn,
        factoryFeedbackPic: order.factoryFeedbackPic
      }
    },
    confirmIn() {
      if (!this.order.factoryFeedbackPic) {
        this.$message.error('请上传回执单')
        return
      }
      let param = {
        agentExportGoodsSn: this.order.sn,
        factoryFeedbackPic: this.order.factoryFeedbackPic
      }
      if (this.isConfirm) {
        this.$apis.store.shopInConfirm(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '收货成功',
              type: 'success'
            })
            this.confirmVisible = false
            this.list()
          }
        })
      } else {
        this.$apis.store.shopInEdit(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.confirmVisible = false
            this.list()
          }
        })
      }
    },
    showPrint(order) {
      if (order) {
        this.order = {
          createDate: order.createDate,
          agentCompanyName: order.agentCompanyName,
          factoryCompanyName: order.factoryCompanyName
        }
        order.agentExportGoodsItemVOS.forEach(item => item.exportNo = order.exportNo)
        this.order.details = order.agentExportGoodsItemVOS
      } else {
        if (this.checkedOrders.length <= 0) {
          this.$message.error('请选择出库单')
          return
        }
        if (this.checkedOrders.reduce((sns, item) => {
          if (!sns.includes(item.factorySn)) {
            sns.push(item.factorySn)
          }
          return sns
        }, []).length > 1) {
          this.$message.error('只能选择同一门店的出库单')
          return
        }
        this.order = {
          createDate: this.checkedOrders[0].createDate,
          agentCompanyName: this.checkedOrders[0].agentCompanyName,
          factoryCompanyName: this.checkedOrders[0].factoryCompanyName
        }
        let details = []
        this.checkedOrders.forEach(o => {
          o.agentExportGoodsItemVOS.forEach(d => {
            d.exportNo = o.exportNo
            details.push(d)
          })
        })
        this.order.details = details.sort((d1, d2) => d1.name.localeCompare(d2.name,'zh-CN')).sort((d1, d2) => d1.type - d2.type)
      }
      this.printVisible = true
    },
    showFeedbackPic(order) {
      this.viewerUrls = [this.$utils.imageSrc(order.factoryFeedbackPic)]
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    }
  },
  created() {
    this.queryParam.userSn = this.currentUser.sn
    this.list()
  }
}
</script>

<style scoped>

</style>